import { render, staticRenderFns } from "./DigitalTicket.vue?vue&type=template&id=378b3379&"
import script from "../../models/analysis/digital-ticket.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/digital-ticket.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports